// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-wrap-price {
    background-color: #140b21;
}

.content-wrap-price .content {
    max-width: 1128px;
    width: 100%;
    margin: 0 auto;
    padding-bottom: 100px;
}

.content-wrap-price .title {
    color: #FFF;
    font-size: 56px;
    font-style: normal;
    font-weight: 700;
    line-height: 68px;
    text-align: center;
    margin-top: 41px;
    font-family: "Inter", sans-serif;
}

.content-wrap-price .sub-title {
    color: #FFF;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px;
    margin-bottom: 0px;
}

.content-wrap-price .description {
    color: #FFF;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    padding-top: 22px;
    font-family: "Inter", sans-serif;
}

@media(max-width: 768px) {
    .content-wrap-price .content {
        padding-bottom: 30px;
    }

    .content-wrap-price {
        padding: 40px 20px;
    }

    .content-wrap-price .title {
        font-size: 25px;
        line-height: 68px;
        margin-top: 10px;
        margin-bottom: 0px;
    }

    .content-wrap-price .sub-title {
        font-size: 20px;
        line-height: 34px;
        padding: 0px 20px;
    }

    .content-wrap-price .description {
        font-size: 15px;
        line-height: 28px;
        padding-bottom: 20px;
        margin-bottom: 0px;
    }



}`, "",{"version":3,"sources":["webpack://./src/pages/Pricing/Pricing.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,oBAAoB;QACpB,kBAAkB;IACtB;;;;AAIJ","sourcesContent":[".content-wrap-price {\n    background-color: #140b21;\n}\n\n.content-wrap-price .content {\n    max-width: 1128px;\n    width: 100%;\n    margin: 0 auto;\n    padding-bottom: 100px;\n}\n\n.content-wrap-price .title {\n    color: #FFF;\n    font-size: 56px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 68px;\n    text-align: center;\n    margin-top: 41px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.content-wrap-price .sub-title {\n    color: #FFF;\n    text-align: center;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 34px;\n    margin-bottom: 0px;\n}\n\n.content-wrap-price .description {\n    color: #FFF;\n    text-align: center;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 28px;\n    padding-top: 22px;\n    font-family: \"Inter\", sans-serif;\n}\n\n@media(max-width: 768px) {\n    .content-wrap-price .content {\n        padding-bottom: 30px;\n    }\n\n    .content-wrap-price {\n        padding: 40px 20px;\n    }\n\n    .content-wrap-price .title {\n        font-size: 25px;\n        line-height: 68px;\n        margin-top: 10px;\n        margin-bottom: 0px;\n    }\n\n    .content-wrap-price .sub-title {\n        font-size: 20px;\n        line-height: 34px;\n        padding: 0px 20px;\n    }\n\n    .content-wrap-price .description {\n        font-size: 15px;\n        line-height: 28px;\n        padding-bottom: 20px;\n        margin-bottom: 0px;\n    }\n\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
